import useScrollTrigger from '@mui/material/useScrollTrigger';
import NRLink from '../../../NRLink/NRLink';
import { CONSTANTS } from '../../../../constants/constants';
import { Fragment, useContext, useEffect } from 'react';
import NRShowMore from '../../../NRShowMore/NRShowMore';
import { VulnDrawerTabsContext } from '../NRVulnerabilityDetails';
import UpperCaseGreyText from '../../../UpperCaseGreyText/UpperCaseGreyText';
import NRTitleWithRightTotal from '../../../NRRightTotal/NRRightTotal';
import NRNoData from '../../../NRDependencies/NRNoData/NRNoData';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';

const { TITLE } = CONSTANTS.TABLE.VULNERABILITIES_TABLE.VULNERABILITY_DETAIL_DRAWER.REFERENCES_SECTION;

const NRReferences = ({ cveDetails, threshold, scrollTarget, index, scrollableId, showName, context, title = TITLE }) => {
  const theme = useTheme();
  const { setScrollSpyTabsValue } = useContext(context || VulnDrawerTabsContext);

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold,
    target: !!scrollTarget ? scrollTarget : undefined
  });

  useEffect(() => {
    setScrollSpyTabsValue(index, trigger);
  }, [trigger]);

  return (
    <Box sx={{ paddingTop: theme.spacing(1.5) }} id={scrollableId}>
      <NRTitleWithRightTotal totalCount={cveDetails?.references?.length || 0} title={title} />
      {!!cveDetails?.references?.length && (
        <NRShowMore
          maxHeight={300}
          items={cveDetails?.references?.map((reference, i) => (
            <Fragment key={`nr-reference-link-${i}`}>
              {reference?.name && !!showName && <UpperCaseGreyText text={reference?.name} />}
              <NRLink url={reference?.url} />
            </Fragment>
          ))}
        />
      )}
      {!cveDetails?.references?.length && <NRNoData noDataTitle={title} />}
    </Box>
  );
};
export default NRReferences;
